import { render, staticRenderFns } from "./CompetitionCategory.vue?vue&type=template&id=63c6732d&scoped=true"
import script from "./CompetitionCategory.vue?vue&type=script&lang=js"
export * from "./CompetitionCategory.vue?vue&type=script&lang=js"
import style0 from "./CompetitionCategory.vue?vue&type=style&index=0&id=63c6732d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6732d",
  null
  
)

export default component.exports